
import Divider from 'vux/src/components/divider/index.vue'

import XButton from 'vux/src/components/x-button/index.vue'

import XNumber from 'vux/src/components/x-number/index.vue'

import Group from 'vux/src/components/group/index.vue'

import CellFormPreview from 'vux/src/components/cell-form-preview/index.vue'

import Cell from 'vux/src/components/cell/index.vue'

import Checker from 'vux/src/components/checker/checker.vue'
import CheckerItem from 'vux/src/components/checker/checker-item.vue'


export default {
name: "SellerRecharge",
components: {
Divider,
XButton,
XNumber,
Group,
CellFormPreview,
Cell,
Checker,
CheckerItem
},
data() {
return {
number: 0,
price: 0,
minAmount: 0,
userId: 0,
nickName: '',
step: 1,

lockButton: false,
list: []
}
},
computed: {
amount() {
return this.number * this.price;
},
isDisabled() {
return this.userId === 0 || this.lockButton === true;
}
},
created() {
this.$vux.loading.show('加载中');
this.$http.get(this.tianYiWebUrl + '/wechat/recharge/userInfo')
.then(res => {
this.$vux.loading.hide();
let r = res.data.data;
if (res.data.code === 200) {
this.price = r.amountPerUnit;
this.minAmount = r.minAmount;
this.number = r.minAmount;
this.userId = r.uid;
this.nickName = r.nick_name;
this.list = r.list;
} else {
this.$vux.toast.show(res.data.message);
}
})
},
methods: {
doPayment(config) {
/*微信支付*/
let self = this;

function onBridgeReady() {
WeixinJSBridge.invoke(
'getBrandWCPayRequest', config,
function (res) {
let _self = this;
if (res.err_msg == "get_brand_wcpay_request:ok") {
self.$vux.loading.hide();

self.$vux.alert.show({
title: '恭喜，充值成功',
content: '请等待入账',
onHide() {
_self.$router.push('/uc/seller_recharge_list')
}
})
} else {
self.$vux.loading.hide();
let errSuffix = '';
if (res.err_desc !== undefined) {
errSuffix = '，(错误:' + res.err_desc + ')';
}

self.$vux.alert.show({
title: '微信支付未完成',
content: '微信支付未完成，请稍后重新尝试支付.' + errSuffix,
});

self.lockButton = false;
}
}
);
}

if (typeof WeixinJSBridge == "undefined") {
if (document.addEventListener) {
document.addEventListener('WeixinJSBridgeReady', onBridgeReady, false);
} else if (document.attachEvent) {
document.attachEvent('WeixinJSBridgeReady', onBridgeReady);
document.attachEvent('onWeixinJSBridgeReady', onBridgeReady);
}
} else {
onBridgeReady();
}
},
recharge() {
if (this.number < this.minAmount) {
this.$vux.alert.show({
title: '出错了',
content: '充值支数不正确'
});
return;
}

if (this.price <= 0) {
this.$vux.alert.show({
title: '出错了',
content: '充值金额不正确'
});
return;
}

let _self = this;
this.$vux.confirm.show({
title: '操作确认',
content: '您要充值的ID是' + this.userId + '，是否继续？',
confirmText: '继续',
onConfirm() {
_self.lockButton = true;
_self.$vux.loading.show();
const url = _self.tianYiWebUrl + '/wechat/recharge/index';
_self.$http.post(url, {uid: _self.uid, number: _self.number}).then(res => {
_self.$vux.loading.hide();
if (res.data.code === 200) {

_self.doPayment(res.data.data);
} else {
_self.$vux.alert.show({
title: '出错了',
content: '系统开小差了'
});
_self.lockButton = false;
}
})
}
});
}
}
}



// WEBPACK FOOTER //
// ./src/components/uc/SellerRecharge.vue